import * as React from 'react'
import { useDrag } from 'react-dnd'

import * as ItemTypes from '@disco/constants/ItemTypes'
import { makeGetGroupLocks } from '@disco/state-management/selectors/groups'

import type { Group } from 'types/group'

import { dndConnectRef } from 'utils/dnd-connect-ref'

import { useSelector } from 'hooks/use-redux'

type Props = {
  group: Group
  children: React.ReactNode
}

export default function CustomGroupDragWrapper({ group, children }: Props) {
  const locked = useSelector(state => {
    const getGroupLocks = makeGetGroupLocks()
    return getGroupLocks(state, { groupId: group.id })?.lock_structure ?? false
  })

  const [{ isDragging }, dragRef] = useDrag<
    { group: Group },
    unknown,
    { isDragging: boolean }
  >(
    () => ({
      type: ItemTypes.GROUP,
      item: { group },
      canDrag: () => !locked || !group.parent,
      collect: monitor => ({ isDragging: monitor.isDragging() }),
    }),
    [group, locked],
  )

  return (
    <div className="GroupDragWrapper" ref={dndConnectRef(dragRef)} style={{ opacity: isDragging ? 0.5 : 1 }}>
      {children}
    </div>
  )
}
